export default {
  conferenceCall: 'Conference Call',
  onHold: 'On Hold',
  ongoing: 'Ongoing',
  unknown: 'Unknown',
  disconnected: 'Disconnected',
  loading: 'Loading ...',
  loadingTimeout: 'Loading timeout.',
} as const;
